import { Col, Row } from 'reactstrap';
import TableActions from 'components/layouts/table';
import Table, { useTable } from 'common/components/table';
import EnumsDropdown from '../../Dropdown';

const VesselSituations = () => {
  const table = useTable({
    label: 'vessel_situations',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        sort: true
      }
    ]
  });

  return (
    <Row className="vessel-situations-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Vessel Situations"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table loader {...table} />
      </Col>
    </Row>
  );
};

export default VesselSituations;
